/*

class to generate workspace

{
  "state" : "<code>" // active || pending || archive || delete
  "workspaceId" : "<string>" //  Because of 1:1 relationship between a workspace and an eoc, team, org or user, the workspaceId is the parentId
  "workspaceType" : "<code>", // user || organization || team || eoc
  "admins" : [adminUserIds]
  "alias" : display name of the workspace
}

*/

// Import libraries
const Joi = require('joi');

// Import variables
const { STATES, WORKSPACE_TYPES } = require('@bcm/constants');
const { DataTableBase } = require('./base.class');
const { joiValidateObj, identifiers } = require('../datastructComponents');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  workspaceType: Joi.string().valid( ...Object.keys(WORKSPACE_TYPES) ).required(),
  workspaceId: Joi.string().required(),
  admins: Joi.array().items( Joi.string().required() ).required(),
  alias: Joi.string().required(),
};

// Define class
class Workspace extends DataTableBase {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    super(
      identifiers.workspace.buildPk(obj.workspaceId),
      identifiers.workspace.buildSk(obj.state, obj.workspaceType, obj.workspaceId),
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.Workspace = Workspace;
exports.workspaceSchema = schema;